import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import qs from 'qs';

import UserList from '../components/UserList';
import Pagination from '../components/Pagination/Pagination';
import {
  getAllUsers,
  getIncludedInGroups,
  getLoggedInUser,
  getPageCount,
} from '../reducers';
import { fetchAllUsers } from '../actions/users';
import OrderedUserList from 'components/OrderedUserList';

class AllUsers extends Component {
  componentDidMount() {
    this.fetchUsers();
  }

  componentDidUpdate(oldProps) {
    if (oldProps.page !== this.props.page) {
      this.fetchUsers();
    }
    if (oldProps.ordering !== this.props.ordering) {
      this.fetchUsers();
    }
  }

  fetchUsers() {
    const { fetchAllUsers, page, childAccounts, userId, ordering } = this.props;
    fetchAllUsers(page, childAccounts, userId, ordering);
  }

  handleChangeOrdering = (value) => {
    const { history, page } = this.props;
    if (page && page !== '1') {
      history.push(`/users/page/1?ordering=${value}`);
    } else {
      history.push({
        search: `?ordering=${value}`,
      });
    }
  };

  getPageNumLink = (pageNum) => {
    const { ordering } = this.props;
    return ordering
      ? `/users/page/${pageNum}?ordering=${ordering}`
      : `/users/page/${pageNum}`;
  };

  render() {
    const {
      users,
      pageCount,
      page,
      childAccounts,
      isReseller,
      loggedInUser,
      ordering,
    } = this.props;
    return (
      <div>
        {childAccounts ? <h1>Child Accounts</h1> : <h1>All Users</h1>}
        {childAccounts ? (
          <UserList childAccounts={childAccounts} users={users} />
        ) : (
          <OrderedUserList
            ordering={ordering}
            changeOrdering={this.handleChangeOrdering}
            users={users}
            isReseller={isReseller}
            loggedInUser={loggedInUser}
          />
        )}

        <Pagination
          count={pageCount}
          current={page}
          url={this.getPageNumLink}
        />
      </div>
    );
  }
}

const mapStateToProps = (
  state,
  {
    childAccounts,
    location: { search },
    match: {
      params: { page = 1, userId },
    },
  },
) => {
  return {
    users: getAllUsers(state, page, childAccounts, userId),
    pageCount: getPageCount(
      state,
      'users',
      childAccounts ? `fetchChildAccounts` : `fetchAll`,
      page,
    ),
    page,
    userId,
    loggedInUser: getLoggedInUser(state),
    isReseller: getIncludedInGroups(state, ['RESELLER']),
    ordering: qs.parse(search, { ignoreQueryPrefix: true }).ordering || '-id',
  };
};

const mapDispatchToProps = {
  fetchAllUsers,
};

AllUsers = withRouter(connect(mapStateToProps, mapDispatchToProps)(AllUsers));

export default AllUsers;
